module.exports = __webpack_public_path__ + "static/img/default_pic.1f1846e.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/default_pic.png
// module id = jL52
// module chunks = 32